module.exports = __webpack_public_path__ + "img/2_img.0b419185.png";